export default "__VITE_ASSET__ipbUr3Zp__"